import React from 'react';

import { useConfiguration } from '../../../context/configurationContext';

import SearchMapClusteredGoogleMaps from './SearchMapClusteredGoogleMaps';
import SearchMapClusteredMapbox from './SearchMapClusteredMapbox';

/**
 * Provider-aware clustered search map.
 *
 * Mirrors the stock SearchMap.js pattern: it renders the Google Maps or Mapbox implementation based
 * on the resolved map provider (config.maps.mapProvider). All props are forwarded unchanged.
 *
 * @component
 * @param {Object} props - Forwarded to the selected implementation (className, rootClassName,
 *   listings, onActivateListing).
 * @returns {JSX.Element}
 */
const SearchMapClustered = props => {
  const config = useConfiguration();
  const isGoogleMapsInUse = config.maps?.mapProvider === 'googleMaps';

  return isGoogleMapsInUse ? (
    <SearchMapClusteredGoogleMaps {...props} />
  ) : (
    <SearchMapClusteredMapbox {...props} />
  );
};

export default SearchMapClustered;
